import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import {
    IAccountDetail,
    IAccountFields,
    IAccountSearch,
} from "../../../../AccountTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import { useDetailModel } from "../detailModel";
import { UserTypeEnum } from "@/types/FmsEnums";
import useGlobalModel from "@/model/globalModel";
import { accountShopService } from "@/views/account/AccountShopService";
type OptionDsType = {
    label: string,
    value: string,
}
export const useAccountModel = createModel(function () {
    const initSearchParam: IAccountFields = {};
    const initDataSource: IAccountDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const { supplierCode } = useDetailModel();
    const { user: { shopCode } } = useGlobalModel();

    //查询条件
    const [searchParam, setSearchParam] = useState<IAccountFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IAccountDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IAccountFields>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [supplierUserDs, setSupplierUserDs] = useState<OptionDsType[]>(); // 选中供应商下的账户列表
    const [supplierUserList, setSupplierUserList] = useState<IAccountDetail[]>(); // 选中供应商下的账户列表

    const [openDrawerVisible, setOpenDrawerVisible] = useState(false);
    const [adjustDrawerVisible, setAdjustDrawerVisible] = useState(false);
    const [rechargeDrawerVisible, setRechargeDrawerVisible] = useState(false);
    const [transferDrawerVisible, setTransferDrawerVisible] = useState(false);
    const [writeoffDrawerVisible, setWriteoffDrawerVisible] = useState(false);

    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
    }

    // 根据条件返回用户options
    const getAccoutSupplierUser = async (data: IAccountFields) => {
        let result = await accountShopService.find({
            partnerCode: supplierCode,
            partnerTypeCode: UserTypeEnum.SUPPLIER,
            ...data,
            shopCode
        })
        return result.retData.map(item => {
            return {
                label: item.name ?? '',
                value: item.code ?? ''
            }
        })
    }

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IAccountFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IAccountFields = searchParam) => {
        const searchParams: IAccountFields = {
            ...searchValue,
            partnerTypeCode: UserTypeEnum.SUPPLIER,
            partnerCode: supplierCode,
            shopCode
            // page: {
            //     pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            //     pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            // }
        }
        let { retData } = await accountShopService.find(searchParams);
        // const {records, ...pg} = retData;
        // setPgCfg(transPgToPagination(pg));
        // setDataSource(records);
        setDataSource(retData);
        clearSelectData();
    }


    return {
        /***field***/
        supplierCode,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        openDrawerVisible,
        adjustDrawerVisible,
        rechargeDrawerVisible,
        transferDrawerVisible,
        writeoffDrawerVisible,
        supplierUserDs,
        supplierUserList,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setOpenDrawerVisible,
        setAdjustDrawerVisible,
        setRechargeDrawerVisible,
        setTransferDrawerVisible,
        setWriteoffDrawerVisible,
        getAccoutSupplierUser,
        onSearch,
        onReset,
        setSelectedData,
        setSupplierUserList,
        setSupplierUserDs,
    }
});
